import { useEffect } from 'react'
import { useAppConfigStore } from '@/stores/appConfigStore'

/**
 * Whether the paid-billing flows are live (API `BILLING_ENABLED`).
 *
 * Self-loading and single-flight, so any billing surface can call it without
 * depending on RootLayout having fetched the config first. Returns `false` until
 * the API answers — failing closed means the UI never offers a checkout the
 * backend would reject with `BILLING_DISABLED`.
 */
export function useBillingEnabled(): boolean {
  const billingEnabled = useAppConfigStore((s) => s.billingEnabled)
  const load = useAppConfigStore((s) => s.load)

  useEffect(() => {
    void load()
  }, [load])

  return billingEnabled
}
